import { API_URLS } from '@chessx/shared/api-routes'
import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import axiosInstance from '../network/axiosInstance'

import { toastErrorMixin, toastMixin } from '../utils/interact'
import type { ApiError } from '../types/api'

interface AdminState {
  updateHero: (heroId: string | undefined | null, params: Record<string, unknown>) => Promise<void>
  fetchUsers: (params: Record<string, unknown>) => Promise<unknown>
  fetchUserData: (params: Record<string, unknown>) => Promise<unknown>
  fetchUserProgress: (params: Record<string, unknown>) => Promise<unknown>
  fetchUserArmy: (params: Record<string, unknown>) => Promise<unknown>
  resetSeason: (uId: string) => Promise<void>
}

const useAdminStore = create<AdminState>()(
  persist(
    (_set, _get) => ({
      updateHero: async (heroId, params) => {
        try {
          if (!heroId) {
            return
          }

          const heroUrl = API_URLS.ADMIN_UPDATE_HERO
          const res = await axiosInstance.put(heroUrl, params)
          if (res?.status === 200) {
            toastMixin.fire({ title: 'Your have successfully updated the item!' })
          }
        } catch (e) {
          const err = e as ApiError
          toastMixin.fire({
            title: `Error updating Hero: ${err?.response?.data?.error}`,
            icon: 'error'
          })
        }
      },
      fetchUsers: async params => {
        try {
          const userUrl = API_URLS.USER
          const res = await axiosInstance.get(userUrl, { params })
          if (res?.status === 200) {
            return res?.data
          }
        } catch (e) {
          const err = e as ApiError
          toastMixin.fire({
            title: `Error fetching users: ${err?.response?.data?.error}`,
            icon: 'error'
          })
        }
      },
      fetchUserData: async params => {
        try {
          const userUrl = API_URLS.ADMIN_USER_DETAIL
          const res = await axiosInstance.get(userUrl, { params })
          if (res?.status === 200) {
            return res?.data
          }
        } catch (e) {
          const err = e as ApiError
          toastMixin.fire({
            title: `Error fetching user details: ${err?.response?.data?.error}`,
            icon: 'error'
          })
        }
      },
      fetchUserProgress: async params => {
        try {
          const userUrl = API_URLS.ADMIN_USER_PROGRESS
          const res = await axiosInstance.get(userUrl, { params })
          if (res?.status === 200) {
            return res?.data
          }
        } catch (e) {
          const err = e as ApiError
          toastMixin.fire({
            title: `Error fetching user progress: ${err?.response?.data?.error}`,
            icon: 'error'
          })
        }
      },
      fetchUserArmy: async params => {
        try {
          const userUrl = API_URLS.ADMIN_USER_ARMY
          const res = await axiosInstance.get(userUrl, { params })
          if (res?.status === 200) {
            return res?.data
          }
        } catch (e) {
          const err = e as ApiError
          toastMixin.fire({
            title: `Error fetching army: ${err?.response?.data?.error}`,
            icon: 'error'
          })
        }
      },
      resetSeason: async uId => {
        try {
          const url = API_URLS.ADMIN_CLEAR_USER_GEM_PASS
          const res = await axiosInstance.post(url, {
            params: { userId: uId }
          })
          toastMixin.fire({
            title: res.data.message.toString()
          })
        } catch (err) {
          toastErrorMixin.fire({
            title: 'Error resetting season.'
          })
        }
      }
    }),
    {
      name: 'admin-storage',
      storage: createJSONStorage(() => localStorage)
    }
  )
)

export default useAdminStore
